import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  connect() {
    this.closeBootstrapModal();
    this.element.remove();
  }

  closeBootstrapModal() {
    const modalEl = document.querySelector(".modal.show");
    if (modalEl && typeof $(modalEl).modal === "function") {
      // Remove the modal from the DOM after it's hidden
      $(modalEl).one('hidden.bs.modal', function () {
        modalEl.remove();
      });

      // Trigger Bootstrap's hide behavior
      $(modalEl).modal('hide');
    }
  }
}
